import $ from 'jquery';
import {findObjectById, getLocacion} from '../../util';


export class PreguntaApi {
    
    static activar(id, token) {  
       return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/pregunta/activar/"+id,
			type: "PUT",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
     static borrar(id, token) {  
       return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/pregunta/"+id,
			type: "DELETE",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
    static getPreguntaList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token ) {
        
         return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/pregunta?page="+pagina+"&size="+regitrosPorPagina+"&filtro="+filtro+"&activos="+showActivos+"&idFormulario="+filtrosCombo.idFormulario,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
      
	}
    
    
    static getPregunta(id, token ) {  
         return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/pregunta/"+id,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
        
	}
    
    
    static save(pregunta, token ) {          
      let preguntaEnvio = Object.assign({}, pregunta);
		let comando="POST";
		if (preguntaEnvio.id > 0) {
			comando="PUT";			
		} 
		preguntaEnvio=JSON.stringify(preguntaEnvio);
		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/pregunta/",
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: preguntaEnvio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
    
    static saveImage(file, token ) {
		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
            url: getLocacion()+ "/api/respuesta/upload/foto",
            contentType: false,
            processData: false,
            type: 'POST',
            data: file,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
    static saveQuestionImage(file, token ) {
		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
            url: getLocacion()+ "/api/pregunta/upload/foto",
            contentType: false,
            processData: false,
            type: 'POST',
            data: file,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
     static deleteQuestionImage(preguntaId, token ) {
		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/pregunta/delete/foto/"+preguntaId,
			type: "DELETE",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
    static getPreguntaCombo(token ) {

		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/pregunta/combo/",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
     

    
}